import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
} from "@mui/material";
import { ScenarioDto } from "../Types/types";

type AddChildDialogProps = {
  open: boolean;
  formData: ScenarioDto;
  onChange: (e: any, field: string) => void;
  onClose: () => void;
  onSave: (type: string) => void;
  type: string;
};

const AddChildDialog: React.FC<AddChildDialogProps> = ({
  open,
  formData,
  onChange,
  onClose,
  onSave,
  type
}) => {
  const handleChangeForm = (e: any, field: string) => {
    console.log(e);
    onChange(e.target.value, field);
  }

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>Add Scenario</DialogTitle>
      <DialogContent>
        <TextField
          label="Id"
          fullWidth
          margin="dense"
          value={formData.id}
          onChange={(e) => handleChangeForm(e, "id")}
        />
        <TextField
          label="title"
          fullWidth
          margin="dense"
          value={formData.title}
          onChange={(e) => handleChangeForm(e, "title")}
        // onChange={(e) => onChange(e.target.value)}
        />
        <TextField
          label="guardian"
          fullWidth
          margin="dense"
          value={formData.guardian}
          onChange={(e) => handleChangeForm(e, "guardian")}
        // onChange={(e) => onChange(e.target.value)}
        />
        <TextField
          label="question"
          fullWidth
          margin="dense"
          value={formData.question}
          onChange={(e) => handleChangeForm(e, "question")}
        // onChange={(e) => onChange(e.target.value)}
        />
        <TextField
          label="hint"
          fullWidth
          margin="dense"
          value={formData.hint}
          onChange={(e) => handleChangeForm(e, "hint")}
        // onChange={(e) => onChange(e.target.value)}
        />
        <TextField
          label="text"
          fullWidth
          margin="dense"
          value={formData.text}
          onChange={(e) => handleChangeForm(e, "text")}
        // onChange={(e) => onChange(e.target.value)}
        />
        <TextField
          label="rootOptionId"
          fullWidth
          margin="dense"
          value={formData.rootOptionId}
          onChange={(e) => handleChangeForm(e, "rootOptionId")}
        // onChange={(e) => onChange(e.target.value)}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button variant="contained" onClick={()=>onSave(type)}>
          Save
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AddChildDialog;
